import EditPage from './EditPage'
import EditPageContainer from './EditPageContainer'
export { EditPage, EditPageContainer }
export default EditPageContainer



// WEBPACK FOOTER //
// ./src/pages/EditPage/index.js